'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var components_NuDSProvider_NuDSProvider = require('../../components/NuDSProvider/NuDSProvider.js');
var utils_intl_intlAriaAttrs = require('../intl/intlAriaAttrs.js');
require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../xstyled-styled-components.es-02f83f64.js');
require('styled-components');
require('../logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../env/isBrowserEnv/isBrowserEnv.js');
require('../env/isTestEnv/isTestEnv.js');
require('../env/isProdEnv/isProdEnv.js');
require('../../extends-f8003900.js');
require('../../index-0e40e0c2.js');
require('../../components/GlobalStyle/GlobalStyle.js');
require('../../theme-41bc4eaa.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../i18n/maybeFormatPrefixedMessage.js');
require('../i18n/maybeFormatMessage.js');

function useIntlAriaAttrs(_ref) {
  var intlAriaKey = _ref.intlAriaKey;
  var nudsContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext);
  return utils_intl_intlAriaAttrs['default'](nudsContext, intlAriaKey);
}

exports.default = useIntlAriaAttrs;
//# sourceMappingURL=useIntlAriaAttrs.js.map
